
export const shouldIncludePageSize = (endpoint: string) => {
  // Heuristic: if the user is hitting the generic fetchItems-style list endpoints, keep page/size.
  // If they are previewing arbitrary pass-through endpoints (sf/*, moodle/*, etc.), omit.
  const ep = (endpoint || "").replace(/^\//, "");

  // Include for Toolbox DB list/table endpoints (adjust as needed)
  if (ep.startsWith("db/")) return true;

  // Common “proxy” style endpoints that usually should NOT get page/size
  if (ep.startsWith("sf/")) return false;
  if (ep.startsWith("joomla/")) return false;
  if (ep.startsWith("moodle/")) return false;

  // Default: keep current behavior (include) unless you prefer safer "false"
  return true;
};